import React, { useState, useEffect } from 'react';
import { motion, useScroll, useSpring, AnimatePresence } from 'framer-motion';
import { FaArrowUp } from 'react-icons/fa';
import { Button, Tooltip } from "@heroui/react";

const ScrollProgress = ({ color = 'primary', showButton = true, buttonPosition = 'right' }) => {
  const [showScrollButton, setShowScrollButton] = useState(false);
  
  // Pobierz informacje o przewijaniu
  const { scrollYProgress } = useScroll();
  
  // Dodaj płynność do wskaźnika postępu
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  
  // Obsługa pokazywania przycisku "do góry" po przewinięciu
  useEffect(() => {
    const unsubscribe = scrollYProgress.on(latest => {
      if (latest > 0.1 && !showScrollButton) {
        setShowScrollButton(true);
      } else if (latest <= 0.1 && showScrollButton) {
        setShowScrollButton(false);
      }
    });
    
    return () => unsubscribe();
  }, [scrollYProgress, showScrollButton]);
  
  // Funkcja przewijania do góry strony
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  // Kolory dla różnych motywów
  const colors = {
    primary: 'bg-primary',
    secondary: 'bg-secondary',
    success: 'bg-success',
    warning: 'bg-warning',
    danger: 'bg-danger'
  };
  
  // Pozycja przycisku
  const buttonPositionClasses = {
    right: 'right-6 bottom-6',
    left: 'left-6 bottom-6',
    center: 'left-1/2 -translate-x-1/2 bottom-6'
  };
  
  return (
    <>
      {/* Pasek postępu przewijania */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-1 z-50 origin-left"
        style={{ scaleX }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        data-testid="scroll-progress-bar"
      >
        <div className={`h-full ${colors[color] || 'bg-primary'}`}></div>
      </motion.div>
      
      {/* Przycisk przewijania do góry */}
      {showButton && (
        <AnimatePresence>
          {showScrollButton && (
            <motion.div
              className={`fixed ${buttonPositionClasses[buttonPosition] || buttonPositionClasses.right} z-50`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              transition={{ type: 'spring', stiffness: 500, damping: 30 }}
              data-testid="scroll-to-top-button"
            >
              <Tooltip content="Wróć do góry" placement="left">
                <Button
                  isIconOnly
                  color={color}
                  variant="shadow"
                  aria-label="Przewiń do góry strony"
                  className="rounded-full w-12 h-12 shadow-lg"
                  onPress={scrollToTop}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      scrollToTop();
                    }
                  }}
                  tabIndex={0}
                >
                  <FaArrowUp />
                </Button>
              </Tooltip>
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </>
  );
};

export default ScrollProgress;